export default "__VITE_ASSET__Cf2d1aUO__"